import { createEnum } from "@redotech/zod-util/zod-enum";

export const AutoMergeDisabledReason = {
  packingSlipPrinted: "packing_slip_printed",
  packingSlipScanned: "packing_slip_scanned",
  split: "split",
  unmerged: "unmerged",
  reship: "reship",
  fulfilledFromBins: "fulfilled_from_bins",
  inventoryTransfer: "inventory_transfer",
  redoCheckoutOrder: "redo_checkout_order",
  retailerPurchaseOrder: "retailer_purchase_order",
} as const;

export type AutoMergeDisabledReason =
  (typeof AutoMergeDisabledReason)[keyof typeof AutoMergeDisabledReason];

export const AutoMergeDisabledReasonSchema = createEnum(
  AutoMergeDisabledReason,
  { enumName: "AutoMergeDisabledReason" },
);

export const AutoMergeDisabledReasonLabels: Record<
  AutoMergeDisabledReason,
  string
> = {
  [AutoMergeDisabledReason.packingSlipPrinted]: "Packing slip printed",
  [AutoMergeDisabledReason.packingSlipScanned]: "Packing slip scanned",
  [AutoMergeDisabledReason.split]: "Split from another shipment",
  [AutoMergeDisabledReason.unmerged]: "Unmerged from another shipment",
  [AutoMergeDisabledReason.reship]: "Reshipment",
  [AutoMergeDisabledReason.fulfilledFromBins]: "Fulfilled directly from bins",
  [AutoMergeDisabledReason.inventoryTransfer]: "Inventory transfer",
  [AutoMergeDisabledReason.redoCheckoutOrder]: "Redo checkout order",
  [AutoMergeDisabledReason.retailerPurchaseOrder]:
    "Retailer purchase order ships alone",
};
